<template>
  <div class="TokenInput" :class="cptdCssState">
    <div class="code">
      <div class="input-container">
        <input
          v-for="(item, index) in size"
          :id="'D' + (index + 1)"
          :key="index + 1"
          class="field"
          inputmode="numeric"
          :maxlength="index === size ? 1 : 5"
          :tabindex="index + 1"
          @input="(inputCode($event), pasteCode($event))"
          @keyup.delete="deleteCode($event)"
        />
      </div>
      <p v-if="cptdIsInvalid" class="error">Código inválido!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenInput',
  props: {
    size: {
      type: [String, Number],
      default: 5,
    },
    invalidCode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  data() {
    return {
      token: [],
    }
  },
  computed: {
    cptdCssState() {
      return {
        '-error': this.cptdIsInvalid,
      }
    },
    cptdIsInvalid() {
      return this.invalidCode && this.token.length === 5
    },
  },
  mounted() {
    const el = document.getElementById('D1')

    el.focus()
  },
  methods: {
    inputCode(e) {
      if (
        e.inputType !== 'deleteContentBackward' &&
        e.inputType !== 'insertFromPaste'
      ) {
        const splitedValue = e.target?.value?.split('')
        const nextEl = document.getElementById('D' + (e.target.tabIndex + 1))

        if (splitedValue?.length > 1) {
          e.target.value = splitedValue[0]
        }

        this.token[e.target?.tabIndex - 1] = e.target.value
        this.token = [...this.token]

        if (nextEl != null) {
          nextEl.focus()
        } else {
          this.submitValue()
        }
      }
    },
    deleteCode(e) {
      const previousElmnt = document.getElementById(
        'D' + (e.target.tabIndex - 1),
      )

      if (previousElmnt != null) {
        e.target.value = ''
        this.token.pop()
        previousElmnt.focus()
      }
    },
    pasteCode(e) {
      if (e.inputType === 'insertFromPaste') {
        const value = e.target.value.split('')

        if (value.length >= this.size) {
          for (let i = 0; i < this.size + 1; i++) {
            const el = document.getElementById('D' + (i + 1))

            if (el) {
              el.value = value[i]
              this.token[i] = value[i]

              if (i === this.size - 1) {
                el.focus()
                this.submitValue()
              }
            }
          }
        }
      }
    },
    submitValue() {
      this.$emit('submit', this.token.join(''))
    },
  },
}
</script>

<style lang="scss">
.TokenInput {
  & > .code {
    & > .input-container {
      position: relative;
      display: flex;
      justify-content: center;
      width: 100%;

      & > .field {
        height: 56px;
        width: 48px;
        background: $color-white-high;
        border: 1px solid $color-neutral-dark;
        box-sizing: border-box;
        border-radius: 5px;
        @include headline-6;
        color: #4e4b59;
        text-align: center;
        transition: all 0.5s ease;

        @include media('xm') {
          width: 56px;
        }

        &:not(:first-child) {
          margin-left: 12px;

          @include desktop {
            margin-left: 24px;
          }
        }

        &:focus {
          outline-color: $color-brand-primary-dark;
        }

        & > .error {
          display: none;
        }
      }
    }
  }
}
.TokenInput {
  &.-error {
    & > .code {
      & > .input-container {
        & > .field {
          border: 1px solid $color-feedback-negative;
          outline-color: $color-feedback-negative;
        }
      }

      & > .error {
        display: block;
        @include caption;
        line-height: 133%;
        color: $color-feedback-negative;
        margin: 8px 0 0 0;
      }
    }
  }
}
</style>
